import { FC, useCallback, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import ModalDialog from '../../common/components/ModalDialog';
import ApplicationsStore from '../stores/applications-store';
import {
  editApplicationOwners,
  useAppOwners,
} from '../../application-owners/api/applications-owners-api';
import AppOwnerEditContent from '../../elements/AppOwnerEdit/AppOwnerEditContent';

const OwnersEditModalContainer: FC<
  React.PropsWithChildren<OwnersEditModalContainerProps>
> = ({ open, setOpen }) => {
  const {
    appOwnersSuggestions,
    editAppOwnerRoleRequest,
    isLoading,
    disableEditAppOwnerAssignSubmit,
  } = useAppOwners();
  const { selectedApp } = useSnapshot(ApplicationsStore);

  const { user } = useAuth0();
  const owners = useMemo(
    () => appOwnersSuggestions.filter(o => o.email !== user?.email),
    [appOwnersSuggestions, user?.email],
  );
  const me =
    user?.email && user?.name
      ? { name: user.name, email: user.email }
      : undefined;
  const onClose = useCallback(() => setOpen(false), [setOpen]);
  const onSubmit = useCallback(async () => {
    await editApplicationOwners();
    onClose();
  }, [onClose]);

  return (
    <>
      {me && editAppOwnerRoleRequest?.role && selectedApp && (
        <ModalDialog
          onClose={onClose}
          modalHeader={`Edit Application ${editAppOwnerRoleRequest.role} Owners`}
          open={open}
          sx={{
            '& [role="dialog"]': {
              overflowY: 'visible',
            },
          }}>
          <AppOwnerEditContent
            saveInProgress={isLoading}
            appOwnersByRole={selectedApp.owners[editAppOwnerRoleRequest.role]}
            appName={selectedApp.appName}
            appId={selectedApp.appId}
            disableAppOwnerEditSubmit={disableEditAppOwnerAssignSubmit}
            onSubmit={onSubmit}
            owners={[me, ...owners]}
            onCancel={onClose}
          />
        </ModalDialog>
      )}
    </>
  );
};

export interface OwnersEditModalContainerProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default OwnersEditModalContainer;
